import React, { useEffect, useState } from 'react';
import { useLanguage } from '../../hooks/Language';

import { Container } from './styles';

const Logo: React.FC = () => {

  const { language } = useLanguage();
  const [logoValue, setLogoValue] = useState("/assets/logo4.png");


  useEffect(() => {

    const validLogo = {
      ptBr: "/assets/logo4.png",
      en: "/assets/logo4.png",
      es: "/assets/logo4.png",
    }


    setLogoValue(validLogo?.[language] ? validLogo[language] : logoValue);

  }, [language])

  return (
    <Container>
      <img src={logoValue} />
    </Container>
  );
};
export default Logo;
